



















import Vue from "vue";
import Component from "vue-class-component";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import DataTable from "@/components/data/data-table.vue";
import TeamsTable from "@/components/tables/teams-table.vue";
import TabsSettings from "@/components/tabs/settings.vue";

// See https://github.com/kaorun343/vue-property-decorator for all options

@Component({
    name: "Teams",
    components: { TabsSettings, Page, PageHeader, DataTable, TeamsTable },
})
export default class Teams extends Vue {}
